module.exports = __webpack_public_path__ + "img/accounting-account-balance-spreadsheet.d53d2b41.svg";